import z from 'zod'
import {
  nameSchema,
  specialtyIndustrySchema,
  specialtySchema,
  postCodeSchema,
  addressSchema,
  homePhoneSchema,
  homepageSchema,
  establishmentSchema,
  invoiceSchema,
  salesValueSchema,
  properValueSchema,
  bpValueSchema,
  deliverAddressSchema,
  dispatchLicenseSchema,
  dispatchLicenseNumberSchema,
  pMarkSchema,
  ismsSchema,
  memoSchema,
  frequencyCodeSchema,
  tagCodeSchema,
  focusCustomerSchema
} from './CompanySchema'
import {
  cellPhoneSchema,
  departmentSchema,
  fullNameSchema,
  mailSchema,
  postSchema
} from 'schema/sales/SalesSchema'

export type CompanyUpdateSchemaType = z.infer<typeof CompanyUpdateSchema>
export const CompanyUpdateSchema = z.object({
  name: nameSchema,
  specialty: specialtySchema,
  specialtyIndustry: specialtyIndustrySchema,
  postCode: postCodeSchema,
  address: addressSchema,
  homePhone: homePhoneSchema,
  homepage: homepageSchema,
  establishment: establishmentSchema,
  invoice: invoiceSchema,
  salesValue: salesValueSchema.optional(),
  properValue: properValueSchema.optional(),
  bpValue: bpValueSchema.optional(),
  deliverAddress: deliverAddressSchema,
  dispatchLicense: dispatchLicenseSchema,
  dispatchLicenseNumber: dispatchLicenseNumberSchema,
  pMark: pMarkSchema,
  isms: ismsSchema,
  memo: memoSchema,
  frequencyCode: frequencyCodeSchema,
  tagCode: tagCodeSchema,
  focusCustomer: focusCustomerSchema,
  sales: z
    .array(
      z.object({
        fullName: fullNameSchema,
        department: z.union([z.literal(''), departmentSchema]),
        cellPhone: z.union([z.literal(''), cellPhoneSchema]),
        post: z.union([z.literal(''), postSchema]),
        mail: mailSchema
      })
    )
    .min(1, { message: '営業を1名以上登録してください' })
})
